import React from "react";
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import sportsCarImg from '../../../src/assets/img/sports-car.svg';
import IconAwesomeUserImg from '../../../src/assets/img/Icon awesome-user.svg';
import IconAwesomeBellImg from '../../../src/assets/img/Icon awesome-bell.svg';
import DollarSymbolImg from '../../../src/assets/img/dollar-symbol.svg';
import FeesImg from '../../../src/assets/img/fees.svg';
import GoogleDocsImg from '../../../src/assets/img/google-docs.svg';
import ProfileImg from '../../../src/assets/img/profile.svg';
import adduser from '../../../src/assets/img/adduser.jpg'
import Path from '../../../src/assets/img/Path.svg'
import API from "../../Services/BaseService";
import { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import locationred from '../../../src/assets/img/locationred.png'
import ls from 'local-storage';

const ManageAccountLinks = (props) => {

    console.log("successData manage account link", props);
    const history = useHistory();
    const location = useLocation();
    const sellerDetails = useSelector(state => state.LoginReducer.payload);
    const dealerData = useSelector((state) => state.DealerReducer.payload);
    const [privilegeDetails, setPrivilegeDetails] = useState("");

    const [accountObjc, setAccountObj] = useState("");
    // const googleMapDetails = ls.get("googleMapDetails")

    const getDealerProfile = (data) => {
        let request = {
            // seller_dealer_id: sellerDetails.seller_dealer_id,
            seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,

            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token,
        };
        const state = API.post('seller_dealer_profile/condition', request);
        state.then(res => {
            console.log("res=======>", res.data.data)
            setAccountObj(res.data.data[0])
        })
            .catch(err => { console.log(err); });
    }

    useEffect(() => {

        getDealerProfile(dealerData)
        privileges(dealerData);
    }, [dealerData])

    const privileges = (data) => {
        let request = {
            seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token,
        }
        API.post("sellerPrivileges/condition", request)
            .then((response) => {
                console.log("privilege", response.data.data[0])
                if (response.data.success === true) {
                    setPrivilegeDetails(response.data.data[0])
                    if (response.data.data[0]?.user_list == 0 && (location.pathname == "/seller" || location.pathname == "/selleredit" || location.pathname == "/adduser")) {
                        history.push('/manageaccount')
                    }
                }

            })
            .catch(function (error) {

            });
    }

    // useEffect(() => {
    //     let request = {
    //         seller_dealer_id: sellerDetails.seller_dealer_id,
    //         seller_id: sellerDetails.seller_id,
    //         seller_token: sellerDetails.seller_token,
    //     };
    //     const state = API.post('seller_dealer_profile/condition', request);
    //     state.then(res => {
    //         console.log("res=======>", res.data.data)
    //         setAccountObj(res.data.data[0])
    //     })
    //         .catch(err => { console.log(err); });
    // }, []);

    const [isOpen, setIsOpen] = useState(false);
    const toggleShow = () => {
        setIsOpen(!isOpen);
    }
    // const defaultProps = {
    //     center: {
    //         lat: googleMapDetails?.latitude,
    //         lng: googleMapDetails?.longitude
    //     },
    //     zoom: 11,
    // };

    return (
        <div>
            <div className="mgaccountuser">
                <div className="mgaccountuserleft">
                    <img alt="Menu" src={accountObjc?.image || adduser} />
                </div>
                <div className="mgaccountuserright">
                    <h3>{accountObjc?.dealer_name}</h3>
                    {/* <h3>{accountObjc?.address}</h3> */}

                    <div className="d-flex align-items-center">
                        <p className="details" onClick={() => toggleShow()}><img src={Path} className="img-fluid" alt="..." /><span>{accountObjc?.address}</span></p>
                    </div>

                </div>
            </div>
            <div className="mgaccountuserlinks">            {/* {isOpen &&
                    <div style={{ height: '200px', width: '200%' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyAF2ErqIjduB793Qav3pXdNcFOoj9dfL6I" }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}
                            id={'google-map-script'}
                        >
                            <div lat={googleMapDetails?.latitude} lng={googleMapDetails?.longitude} >
                                <img className="golMap" alt="Menu" src={locationred} />
                            </div>
                        </GoogleMapReact>
                    </div>
                }  */}
                <div className="userlinks">
                    <ul>
                        <li className={location.pathname === "/manageaccount" ? "active" : ""} ><img src={sportsCarImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => { history.push('/manageaccount'); props.handleFlag() }} >Account</a></li>
                        <li className={location.pathname === "/myprofile" ? "active" : ""} ><img src={IconAwesomeUserImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => { history.push('/myprofile'); props.handleFlag() }} >Myprofile</a></li>
                        <li className={location.pathname === "/notification" ? "active" : ""} ><img src={IconAwesomeBellImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => history.push('/notification')} >Notification</a></li>
                        <li className={location.pathname === "/paymentinfo" ? "active" : ""} ><img src={DollarSymbolImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => history.push('/paymentinfo')} >Payment</a></li>
                        {/* <li className={location.pathname ==="/lotfee"? "active" : ""} ><img src={FeesImg} className="img-fluid" alt=""/><a href="JavaScript:void(0)"  onClick={()=>history.push('/lotfee')} >Lot Fee</a></li> */}
                        <li className={location.pathname === "/document" ? "active" : ""} ><img src={GoogleDocsImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => history.push('/document')}>Document</a></li>
                        {privilegeDetails?.user_list == 0 ? "" :
                            <li className={location.pathname === "/seller" ? "active" : ""} ><img src={ProfileImg} className="img-fluid" alt="" /><a href="JavaScript:void(0)" onClick={() => history.push('/seller')} >Seller</a></li>}
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default ManageAccountLinks;
